//starting floor
var amenityIndex = 0;
var minAmenityIndex = 0;
var maxAmenityIndex;
var amenityTabs, amenityElements;
var swiper2;

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';


//check if floor plan exists on this page
var amenityCarousel = document.getElementById('amenityCarousel');
var previousAmenityArrows, nextAmenityArrows;
var screenWidth = window.innerWidth;
var activeDisplay;

//init function if block exists
if (amenityCarousel) {

  //if large screen
  if (screenWidth >= 1024) {
    activeDisplay = 'block';
  } else if (screenWidth < 1024 && screenWidth >= 768) { // if tablet
    activeDisplay = 'flex';
  } else { //if mobile
    activeDisplay = 'block';
  }

  //attach click listeners to all previous and next buttons
  previousAmenityArrows = amenityCarousel.querySelectorAll('.previousAmenityButton');
  previousAmenityArrows.forEach(previousArrow => {
    previousArrow.addEventListener("click", previousAmenitySelect);
  })
  nextAmenityArrows = amenityCarousel.querySelectorAll('.nextAmenityButton');
  nextAmenityArrows.forEach(nextArrow => {
    nextArrow.addEventListener("click", nextAmenitySelect);
  })

  //query all amenity elements for later use
  amenityElements = amenityCarousel.querySelectorAll('.amenityElement');
  amenityTabs = amenityCarousel.querySelectorAll('.amenityTab');

  //get number of elements
  maxAmenityIndex = (amenityTabs.length) - 1;

  //init
  initActiveTab();
  initTabClickListeners();
  checkAmenityArrowStyling();
  showAmenity();
  highlightActiveTab();
}

//shows active amenity
function showAmenity() {
  //hide all amenity elements
  amenityElements.forEach(function (amenityElement) {
    amenityElement.style.display = "none";
  });

  //determine which amenity to show
  var selectedAmenityClass = '.amenity' + amenityIndex;

  //show all elements associated with selected amenity
  amenityCarousel.querySelectorAll(selectedAmenityClass).forEach(function (selectedAmenityElement) {
    selectedAmenityElement.style.display = 'block';
  });

  var compoundActiveContentClass = selectedAmenityClass + '.amenityContent';
  amenityCarousel.querySelectorAll(compoundActiveContentClass).forEach(function (selectedAmenityElement) {
    selectedAmenityElement.style.display = activeDisplay;
  });
}

//select previous
function previousAmenitySelect() {
  //iterate floor index and ensure it does not go below min (6)
  amenityIndex = amenityIndex - 1;
  if (amenityIndex < minAmenityIndex) {
    amenityIndex = maxAmenityIndex;
  }
  checkAmenityArrowStyling();
  showAmenity();
  highlightActiveTab();
}

//select next
function nextAmenitySelect() {
  //iterate floor index and ensure it does not go above max
  amenityIndex = amenityIndex + 1;
  if (amenityIndex > maxAmenityIndex) {
    amenityIndex = minAmenityIndex;
  }
  checkAmenityArrowStyling();
  showAmenity();
  highlightActiveTab();
}

//highlights active tab
function highlightActiveTab() {
  //hide all amenity elements
  amenityTabs.forEach(function (amenityTab) {
    amenityTab.classList.remove("activeTab");
  });

  //determine which amenity to show
  var selectedAmenityTabClass = '.amenityTab' + amenityIndex;

  //show all elements associated with selected amenity
  amenityCarousel.querySelectorAll(selectedAmenityTabClass).forEach(function (selectedAmenityTab) {
    selectedAmenityTab.classList.add("activeTab");
  });
}

//styles arrows on floor index change
function checkAmenityArrowStyling() {
  // switch (amenityIndex) {
  //   case minAmenityIndex:
  //     previousAmenityArrows.forEach(previousArrow => {
  //       previousArrow.style.opacity = 0.4;
  //       previousArrow.style.pointerEvents = "none";
  //     });
  //     break;
  //   case maxAmenityIndex:
  //     nextAmenityArrows.forEach(nextArrow => {
  //       nextArrow.style.opacity = 0.4;
  //       nextArrow.style.pointerEvents = "none";
  //     });
  //     break;
  //   default:
  //     previousAmenityArrows.forEach(previousArrow => {
  //       previousArrow.style.opacity = 1.0;
  //       previousArrow.style.pointerEvents = "auto";
  //     });
  //     nextAmenityArrows.forEach(nextArrow => {
  //       nextArrow.style.opacity = 1.0;
  //       nextArrow.style.pointerEvents = "auto";
  //     });
  // }
}

//initilized swiper carousel used for text active tabs
function initActiveTab() {
  var swiperContainer = amenityCarousel.getElementsByClassName('amenityGallerySwiper')[0];

  swiper2 = new Swiper(swiperContainer, {
    // Optional parameters
    direction: 'horizontal',
    allowTouchMove: false,
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 30,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

  });
}

//adds click listeners to each tab
function initTabClickListeners() {
  amenityTabs.forEach(tab => {
    var tabIndex = tab.getAttribute("tab-index");
    tab.addEventListener("click", () => {
      amenityTabClick(tabIndex)
    });
  });
}

//naviate to slide based on tab index
function amenityTabClick(tabIndex) {
  amenityIndex = parseInt(tabIndex);
  checkAmenityArrowStyling();
  showAmenity();
  highlightActiveTab();
  swiper2.slideTo(amenityIndex);
}
